// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "assets_3.24.0/js/[name].bundle" + "-" + "c8bd131d5fce5a5bfbea" + "-bundle.js";
};